var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7032 7.98244C22.0947 7.59175 22.0947 6.95749 21.7032 6.5668L21.429 6.29316C21.0387 5.90358 20.4066 5.90358 20.0162 6.29316L12 14.2932L3.9838 6.29316C3.59343 5.90358 2.96137 5.90358 2.57101 6.29316L2.29681 6.5668C1.90534 6.95749 1.90534 7.59175 2.29681 7.98244L11.0384 16.7065C11.2991 16.9667 11.6677 17.0531 12 16.9657C12.3324 17.0531 12.7009 16.9667 12.9616 16.7065L21.7032 7.98244Z",
  fill: "#242625"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.6fdde30b0c1a7b655fd80808bbf4129e.svg";